/* eslint-disable indent */
//Icons
import * as Icon from "@mui/icons-material";
import { UpgrateNotification } from "pages/UserNotifications/UpgrateNotification";
import { ForgotPassword } from "pages/GateKeeper/ForgotPassword";
import { ChangeDomain } from "pages/GateKeeper/ChangeDomain";
import { Login } from "pages/GateKeeper/Login";
import { SendOTP } from "pages/GateKeeper/SendOTP";
//MyZone
import { Calendar } from "pages/MyZone/Calendar";
import { MyLeaves } from "pages/MyZone/MyLeaves";
import EssStatus from "pages/MyZone/Status";
import { MyShift } from "pages/MyZone/MyShift";
import { Payslip } from "pages/MyZone/Payslip";
import { IndividualWorkingHours } from "pages/MyZone/WorkingHours";
import { MyZoneApply } from "pages/MyZone/MyZoneApply";
import { EODReports } from "pages/MyZone/EODReport";
//TeamZone

import { TeamZoneCalendar } from "pages/TeamZone/TeamZoneCalendar";
import { LeaveSummary } from "pages/TeamZone/LeaveSummary";
import { PlanShift } from "pages/TeamZone/PlanShift";
import { ShiftGroupIndex } from "pages/TeamZone/PlanShift/ShiftGroup";
import { Status } from "pages/TeamZone/Attendance/AttendanceStatus/Status";
import { Approve } from "pages/TeamZone/Approve";
import { Reports } from "pages/TeamZone/Reports";
import { TeamEODReports } from "pages/TeamZone/EODReport";
//Administration
import { Companies } from "pages/Administration/Companies";
import { Departments } from "pages/Administration/Departments";
import { CreateUser } from "pages/Administration/CreateUser";
import { Master } from "pages/Administration/Master";
import { Designation } from "pages/Administration/Master/Screens/Designation";
import { EmploymentType } from "pages/Administration/Master/Screens/EmploymentType";
import { WorkUnit } from "pages/Administration/WorkUnit";
import { Users } from "pages/Administration";
import { ViewMembers } from "pages/Administration/Departments/ViewMembers";
import { ViewUserGroup } from "pages/Administration/Companies/UserGroup/ViewUserGroup";
import { ViewCompany } from "pages/Administration/Companies/ViewCompany";
import { EditProfile } from "pages/GateKeeper/EditProfile";
import { NewProjectMain } from "pages/Projects/NewProject";
import { Tasks } from "pages/Projects/Tasks";
import { MyTasks } from "pages/Projects/MyTasks";
import { EditProject } from "pages/Projects/MyProject/EditProject";
import { Project } from "pages/Projects/MyProject";
import { Clients } from "pages/Projects/Clients";
import { ChangePassword } from "pages/GateKeeper/ChangePassword";
import { Attendance } from "pages/TeamZone/Attendance";
import { ProjectDashbard } from "pages/Projects/MyProject/ProjectDashboard";
import { SprintDashboard } from "pages/Projects/MyProject/ProjectDashboard/SprintDashboard";
import { ProjectReports } from "pages/Projects/Reports";
import { ViewGroupMembers } from "pages/Administration/WorkUnit/ViewGroupMembers";
import { BioDevice } from "pages/Administration/Master/Screens/BioDevice";
//PayRoll
import { PayrollReports } from "pages/PayRoll/PayrollReports";
import { ShiftAssignIndex } from "pages/TeamZone/PlanShift/ShiftAssign";
import { NewPassword } from "pages/GateKeeper/SendOTP/NewPassword";
import { RoleAndUserGroup } from "pages/Administration/RoleAndUserGroup";
// payroll updated design
import { EarningComponents } from "pages/PayRoll/Components/EarningComponents";
import { DeductionComponents } from "pages/PayRoll/Components/DeductionComponent";
import { PayrollProcessing } from "pages/PayRoll/Operations/PayrollProcessing";
import { PayrollSetUp } from "pages/PayRoll/Setup";

// import { EmployeeDetails } from "pages/HR/EmployeeDetails";
import { CreateEmployee } from "pages/HR/CreateEmployee";
import { EditEmployee } from "pages/HR/EditEmployee";
import { ExistingUser } from "pages/HR/ExistingUser";
import { TimeOffSettings } from "pages/HR/TimeOffSettings";
import { SalaryConfiguration } from "pages/HR/SalaryConfiguration";
import { EODSettings } from "pages/Administration/Settings";
import { EmployeeOnboard } from "pages/HR/EmployeeOnboard";
import { BulkImport } from "pages/HR/EmployeeOnboard/BulkImport";
import { HRShift } from "pages/HR/Shift";
//Support
import { SupportAdmin } from "pages/SupportAdmin";
//Tracking
import TripHistory from "pages/Tracking/TripHistory";
import { TrackSettings } from "pages/Tracking/Settings";
import PatrolTraking from "pages/Tracking/Patrol";
import { InsufficientPermissions } from "pages/GateKeeper/InsufficientPermissions";

//CRM
import ContactFormPage from "pages/CRM/ContactFormPage";
import EditContactPage from "pages/CRM/EditContactPage";
import AgentDashboard from "pages/CRM/AgentDashBoard";
import SettingsPage from "pages/CRM/Settings";
import Contacts from "pages/CRM/Contacts";
import ReminderSummary from "pages/CRM/ReminderSummary";
import { supportLabel } from "services/constants";

const currentUserString = JSON.parse(localStorage.getItem("currentuser"));

export const getRoutesByRole = (product) => [
  {
    path: "/myzone/calendar",
    name: "My Zone",
    icon: Icon.Person,
    component: Calendar,
    layout: "/admin",
    hideInSidebar: product ? findAccess(product, "My Zone") : true,
    collapse: [
      {
        path: "/admin/myzone/apply",
        name: "Apply",
        icon: Icon.ContactPageSharp,
        layout: "/admin",
      },
      {
        path: "/admin/myzone/calendar",
        name: "Calendar",
        icon: Icon.CalendarMonthSharp,
        layout: "/admin",
      },
      {
        path: "/admin/myzone/myleaves",
        name: "My Leaves",
        icon: Icon.SickSharp,
        layout: "/admin",
      },
      {
        path: "/admin/myzone/myshift",
        name: "Shift",
        icon: Icon.PresentToAll,
        layout: "/admin",
      },
      {
        path: "/admin/myzone/status",
        name: "Status",
        icon: Icon.RotateLeftSharp,
        layout: "/admin",
      },
      {
        path: "/admin/myzone/myworkinghours",
        name: "Working Hours",
        icon: Icon.AvTimerSharp,
        layout: "/admin",
      },
      {
        path: "/admin/myzone/payslip",
        name: "Payslip",
        icon: Icon.Summarize,
        layout: "/admin",
      },
      {
        path: "/admin/myzone/eodreport",
        name: "EOD Report",
        icon: Icon.Assessment,
        layout: "/admin",
      },
    ],
  },
  {
    path: "/teamzone/calendar",
    name: "Team Zone",
    icon: Icon.Diversity3,
    component: TeamZoneCalendar,
    layout: "/admin",
    hideInSidebar: product ? findAccess(product, "Team Zone") : true,
    collapse: [
      {
        path: "/admin/teamzone/approve",
        name: "Approve",
        icon: Icon.PlaylistAddCheckCircle,
        layout: "/admin",
      },
      {
        path: "/admin/teamzone/attendance",
        name: "Attendance",
        icon: Icon.PersonAddAlt1,
        layout: "/admin",
      },
      {
        path: "/admin/teamzone/calendar",
        name: "Calendar",
        icon: Icon.CalendarMonthSharp,
        layout: "/admin",
      },
      {
        path: "/admin/teamzone/leave-summary",
        name: "Leave Summary",
        icon: Icon.TransferWithinAStation,
        layout: "/admin",
      },
      {
        path: "/admin/teamzone/plan-shift",
        name: "Shift",
        icon: Icon.DriveFolderUpload,
        layout: "/admin",
      },
      {
        path: "/admin/teamzone/report",
        name: "Reports",
        icon: Icon.Summarize,
        layout: "/admin",
      },
      {
        path: "/admin/teamzone/eodreport",
        name: "EOD Report",
        icon: Icon.Assessment,
        layout: "/admin",
      },
    ],
  },
  {
    path: "/payroll/setup",
    name: "Payroll",
    icon: Icon.ManageAccounts,
    component: PayrollSetUp,
    layout: "/admin",
    hideInSidebar: product ? findAccess(product, "Payroll") : true,
    collapse: [
      {
        path: "/admin/payroll/reports",
        name: "Reports",
        icon: Icon.DriveFolderUpload,
        layout: "/admin",
      },
      {
        path: "/admin/payroll/components/earning",
        name: "Components",
        icon: Icon.Payment,
        component: EarningComponents, // Default to Earnings
        layout: "/admin",
        hideInSidebar: product ? findAccess(product, "Payroll") : true,
        collapse: [
          {
            path: "/admin/payroll/components/earning",
            name: "Earnings",
            icon: Icon.TrendingUp,
            layout: "/admin",
            component: EarningComponents,
          },
          {
            path: "/admin/payroll/components/deductions",
            name: "Deductions",
            icon: Icon.TrendingDown,
            layout: "/admin",
            component: DeductionComponents,
          },
        ],
      },

      {
        path: "/admin/payroll/operations/processing",
        name: "Operations",
        icon: Icon.Loop,
        component: PayrollProcessing,
        layout: "/admin",
        hideInSidebar: product ? findAccess(product, "Payroll") : true,
        collapse: [
          {
            path: "/admin/payroll/operations/processing",
            name: "Payroll Processing",
            icon: Icon.ScatterPlot,
            layout: "/admin",
            component: PayrollProcessing,
          },
        ],
      },
      {
        path: "/admin/payroll/setup",
        name: "Setup",
        icon: Icon.PhonelinkSetup,
        layout: "/admin",
        component: PayrollSetUp,
      },
    ],
  },
  {
    path: "/project/project-management",
    name: "Project",
    icon: Icon.BusinessCenter,
    component: Project,
    layout: "/admin",
    hideInSidebar: product ? findAccess(product, "Project") : true,
    collapse: [
      {
        path: "/admin/project/clients",
        name: "Clients",
        icon: Icon.ConnectWithoutContact,
        layout: "/admin",
      },
      {
        path: "/admin/project/project-management",
        name: "Projects",
        icon: Icon.AccountTree,
        layout: "/admin",
      },
      {
        path: "/admin/project/mytask",
        name: "Tasks",
        icon: Icon.Checklist,
        layout: "/admin",
      },
      {
        path: "/admin/project/report",
        name: "Reports",
        icon: Icon.DriveFolderUpload,
        layout: "/admin",
      },
    ],
  },
  {
    path: "/administration/user",
    name: "Administration",
    icon: Icon.Person,
    component: Users,
    layout: "/admin",
    hideInSidebar: product ? findAccess(product, "Administration") : true,
    collapse: [
      {
        path: "/admin/administration/companies",
        name: "Companies",
        icon: Icon.Business,
        layout: "/admin",
      },
      {
        path: "/admin/administration/role/usergroup",
        name: "Roles & User Group",
        icon: Icon.SettingsAccessibility,
        layout: "/admin",
      },
      {
        path: "/admin/administration/departments",
        name: "Departments",
        icon: Icon.LocationCity,
        layout: "/admin",
      },
      {
        path: "/admin/administration/workunit",
        name: "Work Unit",
        icon: Icon.Diversity2,
        layout: "/admin",
      },
      {
        path: "/admin/administration/master/designation",
        name: "Master",
        icon: Icon.Person4,
        layout: "/admin",
      },
      {
        path: "/admin/administration/user",
        name: "Users",
        icon: Icon.SupervisedUserCircle,
        layout: "/admin",
      },
      {
        path: "/admin/administration/settings",
        name: "Settings",
        icon: Icon.Settings,
        layout: "/admin",
      },
    ],
  },
  {
    path: "/hrzone/employees",
    name: "HR Zone",
    icon: Icon.ManageAccounts,
    component: EmployeeOnboard,
    layout: "/admin",
    hideInSidebar: product ? findAccess(product, "HR Zone") : true,
    collapse: [
      {
        path: "/admin/hrzone/employees",
        name: "Employee",
        icon: Icon.Badge,
        layout: "/admin",
      },
      {
        path: "/admin/hrzone/shift",
        name: "Shift",
        icon: Icon.FilterTiltShift,
        layout: "/admin",
      },
      {
        path: "/admin/hrzone/timeoff",
        name: "LMS",
        icon: Icon.ContactPageSharp,
        layout: "/admin",
      },
      {
        path: "/admin/hrzone/salaryconfig",
        name: "Salary Configuration",
        icon: Icon.Payments,
        layout: "/admin",
      },
    ],
  },

  {
    path: "/support/admin",
    name: "Support Admin",
    icon: Icon.RecordVoiceOver,
    component: SupportAdmin,
    layout: "/admin",
    hideInSidebar: product ? findAccess(product, "Support Admin") : true,
  },
  {
    path: "/tracking/triphistory",
    name: "Tracking",
    icon: Icon.Diversity3,
    component: TripHistory,
    layout: "/admin",
    hideInSidebar: product ? findAccess(product, "Tracking") : true,
    collapse: [
      {
        path: "/admin/tracking/triphistory",
        name: "Track",
        icon: Icon.QueryStats,
        layout: "/admin",
      },
      {
        path: "/admin/tracking/patroltraking",
        name: "Patrol",
        icon: Icon.LocalPolice,
        layout: "/admin",
      },
      {
        path: "/admin/tracking/settings",
        name: "Settings",
        icon: Icon.Settings,
        layout: "/admin",
      },
    ],
  },
  {
    path: "/crm/contacts",
    name: "CRM",
    icon: Icon.Diversity3,
    component: Contacts,
    layout: "/admin",
    hideInSidebar: product ? findAccess(product, "CRM") : true,
    collapse: [
      {
        path: "/admin/crm/agent",
        name: "Dashboard",
        icon: Icon.Dashboard,
        layout: "/admin",
      },
      {
        path: "/admin/crm/contacts",
        name: "Contacts",
        icon: Icon.Contacts,
        layout: "/admin",
      },
      {
        path: "/admin/crm/reminder",
        name: "Reminders",
        icon: Icon.NotificationsActive,
        layout: "/admin",
      },
      {
        path: "/admin/crm/settings",
        name: "Settings",
        icon: Icon.Settings,
        layout: "/admin",
      },
    ],
  },
  {
    path: "/crm/create",
    name: "CRM",
    component: ContactFormPage,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/crm/edit/:id",
    name: "CRM",
    component: EditContactPage,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/crm/agent",
    name: "CRM",
    component: AgentDashboard,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/crm/reminder",
    name: "CRM",
    component: ReminderSummary,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/crm/settings",
    name: "CRM",
    component: SettingsPage,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/edit/profile",
    name: "Profile",
    component: EditProfile,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/changepassword",
    name: "ChangePassword",
    component: ChangePassword,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    layout: "/auth",
    hideInSidebar: true,
  },
  {
    path: "/send/otp",
    name: "SendOTP",
    component: SendOTP,
    layout: "/auth",
    hideInSidebar: true,
  },
  {
    path: "/otp/newPassword",
    name: "NewPassword",
    component: NewPassword,
    layout: "/auth",
    hideInSidebar: true,
  },
  {
    path: "/forgot-password",
    name: "Register",
    component: ForgotPassword,
    layout: "/auth",
    hideInSidebar: true,
  },
  {
    path: "/maintenance",
    name: "Register",
    component: UpgrateNotification,
    layout: "/auth",
    hideInSidebar: true,
  },
  {
    path: "/project/new-project",
    name: "NewProject",
    component: NewProjectMain,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/project/task",
    name: "Task",
    component: Tasks,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/project/mytask",
    name: "Tasks",
    component: MyTasks,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/project/report",
    name: "Reports",
    component: ProjectReports,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/project/clients",
    name: "Clients",
    component: Clients,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/project/edit/project",
    name: "EditProject",
    component: EditProject,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/project/dashboard",
    name: "Projects",
    component: ProjectDashbard,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/project/sprint/dashboard",
    name: "SprintDashboard",
    component: SprintDashboard,
    layout: "/admin",
    hideInSidebar: true,
  },
  //Invoice
  {
    path: "/administration/create/user",
    name: "CreateUser",
    component: CreateUser,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/administration/workunit",
    name: "WorkUnit",
    component: WorkUnit,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/administration/companies",
    name: "Companies",
    component: Companies,
    layout: "/admin",
    hideInSidebar: true,
  },
  //MyZone
  {
    path: "/myzone/apply",
    name: "Apply Leave",
    component: MyZoneApply,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/myzone/myleaves",
    name: "Apply Leave",
    component: MyLeaves,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/myzone/status",
    name: "Status",
    component: EssStatus,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/myzone/myshift",
    name: "PlanShift",
    component: MyShift,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/myzone/myworkinghours",
    name: "WorkingHours",
    component: IndividualWorkingHours,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/myzone/payslip",
    name: "Payslip",
    component: Payslip,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/myzone/eodreport",
    name: "EOD Report",
    component: EODReports,
    layout: "/admin",
    hideInSidebar: true,
  },
  //Administration

  {
    path: "/administration/departments",
    name: "Departments",
    component: Departments,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/administration/role/usergroup",
    name: "RoleAndUserGroup",
    component: RoleAndUserGroup,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/administration/department/status",
    name: "DepartmentStatus",
    component: Status,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/administration/department/view/members",
    name: "ViewMembers",
    component: ViewMembers,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/administration/work-unit/members",
    name: "WorkUnit",
    component: ViewGroupMembers,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/administration/view/company/groups",
    name: "ViewCompany",
    component: ViewCompany,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/administration/view/user/groups",
    name: "UserGroup",
    component: ViewUserGroup,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/administration/department/plan-shift",
    name: "Shift",
    component: PlanShift,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/administration/master",
    name: "Master",
    component: Master,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/administration/master/designation",
    name: "Designation",
    component: Designation,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/administration/master/employment/type",
    name: "EmploymentType",
    component: EmploymentType,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/administration/master/bio-device",
    name: "BioDevice",
    component: BioDevice,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/administration/settings",
    name: "Settings",
    component: EODSettings,
    layout: "/admin",
    hideInSidebar: true,
  },
  // Team Zone
  {
    path: "/teamzone/leave-summary",
    name: "Leave Summary",
    component: LeaveSummary,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/teamzone/plan-shift",
    name: "Shift",
    component: PlanShift,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/teamzone/shift-group",
    name: "Shift Group",
    component: ShiftGroupIndex,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/teamzone/shift-assignment",
    name: "Shift Assignment",
    component: ShiftAssignIndex,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/teamzone/attendance",
    name: "Attendance",
    component: Attendance,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/teamzone/eodreport",
    name: "EOD Report",
    component: TeamEODReports,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/attendance/view/members",
    name: "ViewMembers",
    component: ViewMembers,
    layout: "/admin",
    hideInSidebar: true,
  },

  {
    path: "/teamzone/attendances/status",
    name: "Status",
    component: Status,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/teamzone/approve",
    name: "Approve",
    component: Approve,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/teamzone/report",
    name: "Reports",
    component: Reports,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/payroll/reports",
    name: "Payroll Reports",
    component: PayrollReports,
    layout: "/admin",
    hideInSidebar: true,
  },

  // updated payroll design
  {
    path: "/payroll/components/earning",
    name: "Earnings",
    component: EarningComponents,
    layout: "/admin",
    hideInSidebar: true,
  },

  {
    path: "/payroll/components/deductions",
    name: "Deductions",
    component: DeductionComponents,
    layout: "/admin",
    hideInSidebar: true,
  },

  {
    path: "/payroll/operations/processing",
    name: "Payroll Processing",
    component: PayrollProcessing,
    layout: "/admin",
    hideInSidebar: true,
  },

  {
    path: "/payroll/setup",
    name: "Setup",
    component: PayrollSetUp,
    layout: "/admin",
    hideInSidebar: true,
  },

  //HR module
  {
    path: "/hrzone/employees",
    name: "HR Zone",
    component: EmployeeOnboard,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/hrzone/edit/employees",
    name: "EditEmployee",
    component: EditEmployee,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/hrzone/create_new/employee",
    name: "CreateEmployee",
    component: CreateEmployee,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/hrzone/existing/employee",
    name: "ExistingUser",
    component: ExistingUser,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/hrzone/bulk/import",
    name: "BulkImport",
    component: BulkImport,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/change/domain",
    name: "ChangeDomain",
    component: ChangeDomain,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/hrzone/timeoff",
    name: "LMS",
    component: TimeOffSettings,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/hrzone/salaryconfig",
    name: "LMS",
    component: SalaryConfiguration,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/tracking/patroltraking",
    name: "Patrol",
    component: PatrolTraking,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/tracking/settings",
    name: "LMS",
    component: TrackSettings,
    layout: "/admin",
    hideInSidebar: true,
  },

  {
    path: "/insufficient/permissions",
    name: "LMS",
    component: InsufficientPermissions,
    layout: "/admin",
    hideInSidebar: true,
  },
  {
    path: "/hrzone/shift",
    name: "Shift",
    component: HRShift,
    layout: "/admin",
    hideInSidebar: true,
  },
];

const findAccess = (productDetails, productName) => {
  if (productName === supportLabel) {
    return currentUserString?.type === supportLabel ? false : true;
  } else {
    let module = productDetails.filter((data) => {
      return data.product_name === productName;
    });
    return module.length > 0 ? false : true;
  }
};
